export class CreateDirOrFile {
    path: string;
    name: string;
    isDir: boolean;

    constructor(parentPath: string, fileName: string, isDir: boolean) {
        this.path = `${parentPath}`;
        this.name = fileName;
        this.isDir = isDir;
    }
}
